export function isNumeric(value: any): boolean {
  return Number.isFinite(parseInt(String(value), 10));
}
